<template>
    <a :href="'tel:' + callNumber"
       class="phone"
       :aria-label="'Click on phone number to call ' + tel">
        <span>{{ tel }}</span>
    </a>
</template>

<script>
export default {
  props: {
    phone: String,
  },
  data() {
    return {
      tel: '',
      callNumber: '',
    };
  },
  watch: {
    phone: {
      immediate: true,
      handler(value) {
        if (!this.$_.isString(value)) {
          return;
        }

        let telString = value.replace(/\D/g, '');
        let length = telString.length;

        switch (length) {
          case 0:
            this.tel = '';
            this.callNumber = '';
            break;
          case 10:
            this.tel = '(' + telString.slice(0, 3) + ') ' + telString.slice(3, 6) + '-' + telString.slice(6, 10);
            this.callNumber = telString;
            break;
          case 11:
            this.tel = '+' + telString.slice(0, 1) + ' (' + telString.slice(1, 4) + ') ' + telString.slice(4, 7) + '-' +
                telString.slice(7, 11);
            this.callNumber = telString;
            break;
          default:
            this.tel = value;
            this.callNumber = telString;
        }
      },
    },
  },
};

</script>
